import { DynamicFilterConfig } from "../../../components/DynamicComponent/DynamicFilterPanel";
import useApi from "../../../services/useApi";

export const dynamicFilterConfig: DynamicFilterConfig = {
  "Date Range": {
    label: "Date Range",
    type: "date",
    required: false,
    searchKey: {
      start: "transaction_start_date",
      end: "transaction_end_date",
    },
  },
  "Transaction Status": {
    label: "Transaction Status",
    type: "radio",
    options: ["All", "Success", "Failed"],
    default: "All",
    required: false,
    searchKey: "status",
  },
  "Source Channel": {
    label: "Source Channel",
    type: "radio",
    options: ["All", "Web", "Mobile", "USSD"],
    default: "All",
    required: false,
    searchKey: "source_channel",
  },
};

export const unsuccessfulTransactionFilterConfig: DynamicFilterConfig = {
  "Date Range": {
    label: "Date Range",
    type: "date",
    required: false,
    searchKey: {
      start: "transaction_start_date",
      end: "transaction_end_date",
    },
  },
  "Transaction Type": {
    label: "Transaction Type",
    type: "radio",
    options: ["All", "Recharge", "eTop Up Purchase"],
    default: "All",
    required: false,
    searchKey: "transaction_type",
  },
  "Source Channel": {
    label: "Source Channel",
    type: "radio",
    options: ["All", "Web", "Mobile", "USSD"],
    default: "All",
    required: false,
    searchKey: "source_channel",
  },
};

export const purchasedOrderFilterConfig: DynamicFilterConfig = {
  "Date Range": {
    label: "Date Range",
    type: "date",
    required: false,
    searchKey: {
      start: "transaction_start_date",
      end: "transaction_end_date",
    },
  },
  "Mode of Transaction": {
    label: "Mode of Transaction",
    type: "checkbox",
    options: [
      "Bank",
      "Cash",
      "M-Paisa",
      "My Money",
      "MoMo",
      "Hesab Pay",
      "M-Hawala",
    ],
    required: false,
    searchKey: "mode_of_payment",
  },
  "Payment Type": {
    label: "Payment Type",
    type: "radio",
    options: ["All", "Paid", "Advance"],
    default: "All",
    required: false,
    searchKey: "payment_type",
  },
  "Source Channel": {
    label: "Source Channel",
    type: "radio",
    options: ["All", "Web", "Mobile", "USSD"],
    default: "All",
    required: false,
    searchKey: "source_channel",
  },
};

export const stockAccountStatementFilterConfig: DynamicFilterConfig = {
  "Date Range": {
    label: "Date Range",
    type: "date",
    required: false,
    searchKey: {
      start: "transaction_start_date",
      end: "transaction_end_date",
    },
  },
};

export const upfrontSalesFilterConfig: DynamicFilterConfig = {
  "Date Range": {
    label: "Date Range",
    type: "date",
    required: false,
    searchKey: {
      start: "transaction_start_date",
      end: "transaction_end_date",
    },
  },
  "Source Channel": {
    label: "Source Channel",
    type: "radio",
    options: ["All", "Web", "Mobile", "USSD"],
    default: "All",
    required: false,
    searchKey: "source_channel",
  },
};

export const mnoServiceFeeEarnedConfig: DynamicFilterConfig = {
  "Date Range": {
    label: "Date Range",
    type: "date",
    required: false,
    searchKey: {
      start: "start_date",
      end: "end_date",
    },
  },
  "Service Fee Type": {
    label: "Service Fee Type",
    type: "radio",
    options: ["All", "Upfront", "Postpaid", "On Target Achievement"],
    default: "All",
    required: false,
    searchKey: "service_fee_type",
  },
};
export const mnoWiseEtopupFilterConfig: DynamicFilterConfig = {
  "Purchased Date": {
    label: "Purchased Date",
    type: "date",
    required: false,
    searchKey: {
      start: "purchased_start_date",
      end: "purchased_end_date",
    },
  },
  "Processed Date": {
    label: "Processed Date",
    type: "date",
    required: false,
    searchKey: {
      start: "processed_start_date",
      end: "processed_end_date",
    },
  },
  "Payment Type": {
    label: "Payment Type",
    type: "radio",
    options: ["All", "Paid", "Advance"],
    default: "All",
    required: false,
    searchKey: "payment_type",
  },
  "Payment Mode": {
    label: "Payment Mode",
    type: "radio",
    options: ["All", "Bank", "Cash"],
    default: "All",
    required: false,
    searchKey: "payment_mode",
  },
};

export const onTargetAchievementOfMNOFilterConfig: DynamicFilterConfig = {
  "Date Range": {
    label: "Date Range",
    type: "date",
    required: false,
    searchKey: {
      start: "transaction_start_date",
      end: "transaction_end_date",
    },
  }
};

export const reversalReportFilterConfig: DynamicFilterConfig = {
  "Date Range": {
    label: "Date Range",
    type: "date",
    required: false,
    searchKey: {
      start: "transaction_start_date",
      end: "transaction_end_date",
    },
  }
};


export const profitabilityReportFilterConfig: DynamicFilterConfig = {
  "Date Range": {
    label: "Date Range",
    type: "date",
    required: false,
    searchKey: {
      start: "transaction_start_date",
      end: "transaction_end_date",
    },
  },
};

export const cvmReportFilterConfig: DynamicFilterConfig = {
  "Date Range": {
    label: "Date Range",
    type: "date",
    required: false,
    searchKey: {
      start: "transaction_start_date",
      end: "transaction_end_date",
    },
  },
};

export const etopUpSalesTrendFilterConfig: DynamicFilterConfig = {
  "Date Range": {
    label: "Date Range",
    type: "date",
    required: false,
    searchKey: {
      start: "transaction_start_date",
      end: "transaction_end_date",
    },
  },
};

export const getFilterConfigByType = (type: string, mnoNames?: Array<{id: string, name: string}>, mnoApiFailed?: boolean) => {
  switch (type) {
    case "Unsuccessful Transaction Report":
      return unsuccessfulTransactionFilterConfig;

    case "eTop Up Recharge Report":
      return dynamicFilterConfig;

    case "Stock Transfer Report":
      return purchasedOrderFilterConfig;

    case "Account Statement Report":
      return stockAccountStatementFilterConfig;

    case "MNO Wise eTop Up Purchase Report":
      return mnoWiseEtopupFilterConfig

    case "Upfront Sales Report":
      return upfrontSalesFilterConfig;

    case "Upfront Purchase Report":
      return getUpfrontPurchaseConfig(mnoNames, mnoApiFailed);

    case "Geographical Sales Report":
      return getGeographicalSalesConfig(mnoNames, mnoApiFailed);

    case "MNO's Service Fee Earned Report":
      return mnoServiceFeeEarnedConfig;

    case "On Target Achievement of MNO Report":
      return onTargetAchievementOfMNOFilterConfig;

    case "Reversal Report":
      return reversalReportFilterConfig;

    case "ZoodPay Profitability Report":
      return profitabilityReportFilterConfig;

    case "CVM Report":
      return cvmReportFilterConfig;

    case "MNO Wise Sales Trend Report":
      return etopUpSalesTrendFilterConfig;
    default:
      // Return a default configuration or an empty object if no type matches
      console.warn(`No table details found for type: ${type}. Returning default.`);
      return dynamicFilterConfig;
  }
};

export const getUpfrontPurchaseConfig = (mnoNames?: Array<{id: string, name: string}> | undefined, mnoApiFailed?: boolean): DynamicFilterConfig => {
  // Handle API failure case
  if (mnoNames === undefined && mnoApiFailed) {
    return {
      "Date Range": {
        label: "Date Range",
        type: "date",
        required: false,
        searchKey: {
          start: "transaction_start_date",
          end: "transaction_end_date",
        },
      },
      "MNO Name": {
        label: "MNO Name",
        type: "radio",
        options: ["Failed to fetch"],
        default: "Failed to fetch",
        required: false,
        searchKey: "mno_name",
        valueMapping: {
          "Failed to fetch": ""
        }
      },
    };
  }

  // Handle successful API response
  const mnoOptions = mnoNames && mnoNames.length > 0
    ? ["All", ...mnoNames.map(mno => mno.name)]
    : [];

  // Create value mapping for MNO names to IDs
  const valueMapping: { [key: string]: string } = {
    "All": ""
  };
  if (mnoNames && mnoNames.length > 0) {
    mnoNames.forEach(mno => {
      valueMapping[mno.name] = mno.id;
    });
  }
  const reverseValueMapping: { [key: string]: string } = {};
  if (mnoNames && mnoNames.length > 0) {
    mnoNames.forEach(mno => {
      reverseValueMapping[mno.id] = mno.name;
    });
  }

  return {
    "Date Range": {
      label: "Date Range",
      type: "date",
      required: false,
      searchKey: {
        start: "transaction_start_date",
        end: "transaction_end_date",
      },
    },
    "MNO Name": {
      label: "MNO Name",
      type: "radio",
      options: mnoOptions,
      default: "All",
      required: false,
      searchKey: "mno_ids",
      valueMapping: valueMapping,
      reverseMapping: reverseValueMapping
    },
  };
};

export const getGeographicalSalesConfig = (mnoNames?: Array<{id: string, name: string}> | undefined, mnoApiFailed?: boolean): DynamicFilterConfig => {
  // Handle API failure case
  if (mnoNames === undefined && mnoApiFailed) {
    return {
      "Date Range": {
        label: "Date Range",
        type: "date",
        required: true,
        searchKey: {
          start: "transaction_start_date",
          end: "transaction_end_date",
        },
      },
      "MNO Name": {
        label: "MNO Name",
        type: "checkbox",
        options: ["Failed to fetch"],
        default: "Failed to fetch",
        required: false,
        searchKey: "mno_name",
        valueMapping: {
          "Failed to fetch": ""
        }
      },
    };
  }

  // Handle successful API response
  const mnoOptions = mnoNames && mnoNames.length > 0
    ? [...mnoNames.map(mno => mno.name)]
    : [];

  // Create value mapping for MNO names to IDs
  const valueMapping: { [key: string]: string } = {};
  if (mnoNames && mnoNames.length > 0) {
    mnoNames.forEach(mno => {
      valueMapping[mno.name] = mno.id;
    });
  }
  const reverseValueMapping: { [key: string]: string } = {};
  if (mnoNames && mnoNames.length > 0) {
    mnoNames.forEach(mno => {
      reverseValueMapping[mno.id] = mno.name;
    });
  }

  return {
    "Date Range": {
      label: "Date Range",
      type: "date",
      required: true,
      searchKey: {
        start: "transaction_start_date",
        end: "transaction_end_date",
      },
    },
    "MNO Name": {
      label: "MNO Name",
      type: "checkbox",
      options: mnoOptions,
      default: "All",
      required: false,
      searchKey: "mno_ids",
      valueMapping: valueMapping,
      reverseMapping: reverseValueMapping
    },
  };
};

export const useFetchMnoNames = () => {
  const api = useApi();
  
  const fetchMnoNames = async () => {
    const response = await api.getAPI('mnos?deployment_status=DEPLOYED');
    return response.data.data.map((mno: { id: string; name: string }) => ({
      id: mno.id,
      name: mno.name
    }));
  };
  
  return { fetchMnoNames };
}
